/** webm/opus の MIME タイプ。MediaRecorder の第一候補。 */
const MIME_TYPE_WEBM_OPUS = 'audio/webm;codecs=opus'

/** mp4 の MIME タイプ。iOS Safari など webm 非対応環境向けフォールバック。 */
const MIME_TYPE_MP4 = 'audio/mp4'

/** サポート対象の録音拡張子 */
export type RecordingExtension = 'webm' | 'mp4'

/**
 * サポートされている録音用 MIME タイプと対応する拡張子を返す。
 * webm/opus を優先し、未対応時は mp4 にフォールバックする（iOS Safari 対応）。
 * どちらもサポートされていない場合は例外を投げる。
 */
export function getRecordingMimeType(): {
  mimeType: string
  extension: RecordingExtension
} {
  if (MediaRecorder.isTypeSupported(MIME_TYPE_WEBM_OPUS)) {
    return { mimeType: MIME_TYPE_WEBM_OPUS, extension: 'webm' }
  }
  if (MediaRecorder.isTypeSupported(MIME_TYPE_MP4)) {
    return { mimeType: MIME_TYPE_MP4, extension: 'mp4' }
  }
  throw new Error('No supported audio MIME type found')
}
